import React, { useEffect } from 'react';
import { Icon as LegacyIcon } from '@ant-design/compatible';
import { Result } from 'antd';
import UIStore from '@/stores/UIStore';
import FourOhFour from 'pages/404';

const FormSubmissionResult = ({status, title, subTitle, extra, icon, ...props}) => {



    const show_status = props?.location?.state?.status ? props.location.state.status : status;
    const show_title = props?.location?.state?.title ? props.location.state.title : title;
    const show_subTitle = props?.location?.state?.subTitle ? props.location.state.subTitle : subTitle;
    const show_extra = props?.location?.state?.extra ? props.location.state.extra : extra;
    const show_icon = props?.location?.state?.icon ? props.location.state.icon : icon;

    useEffect(() => {
        UIStore.setDocumentTitle(show_title || '404')
    }, []);

    if(show_status || show_title || show_subTitle || show_extra || show_icon) {
        return (
            <Result
                status={show_status}
                title={show_title}
                subTitle={show_subTitle}
                extra={show_extra}
                icon={<LegacyIcon type={icon} />}
            />
        );
    }

    return (<FourOhFour />)
}

export default FormSubmissionResult;
